import React, { useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { Flex } from '@rebass/grid'

const ADSENSE_CLIENT_ID = 'ca-pub-5119586228664681'

const AdSense = ({ adSlotId, containerProps, ...props }) => {
  const [unFilled, setUnFilled] = useState(false)
  const insRef = useRef(null)

  const Container = useMemo(() => {
    return !isEmpty(containerProps) ? Flex : React.Fragment
  }, [containerProps])

  useEffect(() => {
    if (!insRef.current) return
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes'
          && mutation.attributeName === 'data-ad-status'
        ) {
          const status = insRef.current.getAttribute('data-ad-status')
          if (status === 'unfilled') {
            setUnFilled(true)
          }
        }
      })
    })
    observer.observe(insRef.current, {
      attributes: true,
      attributeFilter: ['data-ad-status'],
    })
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    try {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
    } catch (err) {
      console.error('[AdSense] err', err)
    }
  }, [])

  return !unFilled ? (
    <Container {...containerProps}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        data-ad-client={ADSENSE_CLIENT_ID}
        data-ad-slot={adSlotId}
        data-full-width-responsive="true"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
        {...props}
      />
    </Container>
  ) : null
}

AdSense.propTypes = {
  adSlotId: PropTypes.string,
  containerProps: PropTypes.object,
}

AdSense.defaultProps = {
  adSlotId: null,
  containerProps: {},
}

export default AdSense
